import React, { useState } from "react";
import ReactPlayer from "react-player/youtube";
import { ExplanationStyled } from "./ExplanationStyled";

const Explanation = () => {
  const [showModal, setShowModal] = useState(false);

  const handleButtonClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <ExplanationStyled>
      <ExplanationStyled.UpperPart>
        <ExplanationStyled.Title>2. Insira no Gmail</ExplanationStyled.Title>
        <ExplanationStyled.Subtitle>
          Após fazer download, siga o passo a passo abaixo para inserir sua assinatura no Gmail.
        </ExplanationStyled.Subtitle>
      </ExplanationStyled.UpperPart>

      <ExplanationStyled.MidPart>
        <ExplanationStyled.Button onClick={handleButtonClick}>
          <ExplanationStyled.PlayIcon />
          <ExplanationStyled.ButtonText>Assistir vídeo tutorial</ExplanationStyled.ButtonText>
        </ExplanationStyled.Button>
      </ExplanationStyled.MidPart>

      <ExplanationStyled.BottomPart>
        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>1.  </span>
          Abra o arquivo da assinatura no Google Chrome.
        </ExplanationStyled.Text>

        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>2.  </span>
          Selecione a assinatura (Ctrl + A).
        </ExplanationStyled.Text>

        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>3.  </span>
          Copie a assinatura selecionada (Ctrl + C).
        </ExplanationStyled.Text>

        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>4.  </span>
          No ícone de configurações do Gmail, clique em “Ver todas as configurações”.
        </ExplanationStyled.Text>

        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>5.  </span>
          Desça a página até a seção de Assinatura.
        </ExplanationStyled.Text>

        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>6.  </span>
          Aperte em criar nova assinatura e a nomeie.
        </ExplanationStyled.Text>

        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>7.  </span>
          No espaço de texto, cole a assinatura copiada (Ctrl + V).
        </ExplanationStyled.Text>

        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>8.  </span>
          Em Padrões de assinatura, selecione a que deseja utilizar nos e-mails.
        </ExplanationStyled.Text>

        <ExplanationStyled.Text>
          <span style={{ fontWeight: "700", color: "#008CFF" }}>9.  </span>
          Desça a página e aperte em Salvar alterações.
        </ExplanationStyled.Text>
      </ExplanationStyled.BottomPart>

      {showModal && (
        <ExplanationStyled.Modal>
          <ExplanationStyled.ModalContent>
            <ExplanationStyled.CloseButton onClick={handleCloseModal}>×</ExplanationStyled.CloseButton>
            <ReactPlayer
              url="https://www.youtube.com/watch?v=yNw9tmllAfE"
              controls
              width="100%"
              height="100%"
            />
          </ExplanationStyled.ModalContent>
        </ExplanationStyled.Modal>
      )}
    </ExplanationStyled>
  );
};

export default Explanation;
